const CopyRight = () => {
  return (
    <div className="mt-8 text-center text-xs text-slate-500">
      <p>
        © {new Date().getFullYear()} Nimbus Providers. All rights reserved.
      </p>
    </div>
  );
};

export default CopyRight;
